import OCRWizard from "./OCRWizard";

export default OCRWizard;
